import React from "react";

import { ISchoolCountAnswers } from "../../../state";

import styles from "./Home.module.scss";

export type Props = {
  school?: ISchoolCountAnswers;
  onlyAssessment: boolean;
};

const Home: React.FC<Props> = ({ school, onlyAssessment }) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>ENAGEED</p>
      {!onlyAssessment && (
        <div className={styles.footer}>
          <div className={styles.details}>
            <p>日本中で生まれたアイデアの数</p>
            <div className={styles.total}>
              <p className={styles.circle} />
              <p className={styles.count}>{school?.total_answers ?? 0}</p>
            </div>
          </div>
          <div className={styles.details}>
            <p>{school?.name ?? "---"}で生まれたアイデアの数</p>
            <div className={styles.total}>
              <p className={styles.circle2} />
              <p className={styles.count}>
                {school?.total_answers_school_year ?? 0}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
